module.exports = __webpack_public_path__ + "img/profile-2user.f20804e1.svg";